<template>
  <div>
    <form-wrapper :validator="$v.model">
      <b-row>
        <b-col sm="6">
          <b-form-group id="input-group-1" label-for="input-1">
            <template #label>
              <strong>{{ $t('quoteOfferForm.emailLabel') }} </strong>
            </template>
            <b-form-input
              id="input-1"
              v-model="model.email"
              type="email"
              :placeholder="$t('quoteOfferForm.emailPlaceHolder')"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              :state="$v.model.email.$error ? false : null"
              @change="$v.model.email.$touch()"
              :readonly="loading"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            id="input-group-2"
            :label="$t('quoteOfferForm.progressIdLabel')"
            label-for="input-2"
          >
            <template #label>
              <strong
                >{{ $t('quoteOfferForm.progressIdLabel') }}
                <font-awesome-icon
                  id="icon-input-2"
                  name="icon-input-2"
                  prefix="far"
                  icon="question-circle"
                  @click="onClick"
                />
              </strong>
            </template>
            <b-form-input
              id="input-2"
              v-model="model.progress"
              :type="'number'"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              :state="$v.model.progress.$error ? false : null"
              @change="$v.model.progress.$touch()"
              :placeholder="$t('quoteOfferForm.progressPlaceHolder')"
              :readonly="loading"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col align="right">
          <b-button
            type="submit"
            variant="primary"
            class="mx-2 mb-3"
            :disabled="loading"
            @click="onSubmit"
          >
            <b-spinner v-if="loading" small></b-spinner>{{ $t('find') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="reservationNotFound" class="mt-2">
        <b-col>
          <b-alert show variant="warning"
            >{{ $t('quoteOfferForm.reservationNotFound') }}
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="reservations && reservations.length > 0">
        <b-col>
          <b-alert show variant="warning">
            {{ $t('quoteOfferForm.foundReservations') }}
            <ul>
              <li v-for="(reservation, i) in reservations" :key="i">
                <span
                  v-html="
                    $t('quoteOfferForm.reservation', {
                      progress: reservation.progress,
                      start: reservation.checkIn,
                      end: reservation.checkOut,
                    })
                  "
                />

                <a
                  href="#"
                  v-on:click.prevent="connectReservation(reservation.progress)"
                >
                  {{ $t('proceed') }}</a
                >
              </li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>
      <div style="margin-bottom: 20px">
        <form-summary :attributes="attributes" />
      </div>
    </form-wrapper>
    <b-modal
      id="find-reservation-number-modal"
      v-model="showModal"
      hide-footer
      hide-title
    >
      <template>
        <span
          v-html="$t('quoteOfferForm.reservationHtmlLabel')"
        ></span> </template
    ></b-modal>
  </div>
</template>

<script>
import { LocalStorage } from '@/common/LocalStorage';
import { OfferRequestService } from '@/common/ApiService';
import { format } from 'date-fns';
import {
  required,
  integer,
  minLength,
  maxLength,
  email,
  between,
} from 'vuelidate/lib/validators';

export default {
  name: 'ReservationInfoFromProgress',
  props: {
    value: {
      type: Date,
      required: true,
    },
    propertyCODE: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      date: this.value,
      reservationNotFound: false,
      showModal: false,
      model: {
        progress: null,
        reservationID: null,
        email: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        startDate: null,
        endDate: null,
      },
      reservations: [],
      // form: {
      //   progress: null,
      //   email: '',
      //   checkIn: null,
      // },
      attributes: {
        email: this.$t('form.email'),
        progress: this.$t('form.reservationId'),
      },
    };
  },
  validations: {
    model: {
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      progress: { required, integer: between(0, 2147483647) },
    },
  },
  async created() {
    if (
      (this.$route.query || {}).contactID &&
      (this.$route.query || {}).reservationID
    ) {
      let reservationID = parseInt(this.$route.query.reservationID);
      let contactID = parseInt(this.$route.query.contactID);
      let params = { reservationID, contactID };
      let response = await OfferRequestService.getReservationInfoAsync(params);
      if (response.data) {
        const progress = parseInt(response.data.progress);
        const model = response.data;
        let reservations = [
          {
            reservationID: parseInt(this.$route.query.reservationID),
            checkIn: model.checkIn,
            checkOut: model.checkOut,
            progress: progress,
            firstName: model.firstName,
            surname: model.surname,
            email: model.email,
            phoneNumber: model.phoneNumber,
          },
        ];
        if (Boolean(reservations[0])) {
          reservations[0].contactID = contactID;
        }
        this.populateReservationsFound(reservations);
        this.populateInfoContact(reservations[0]);
        this.connectReservation(progress);
      }
    }
  },
  methods: {
    onClick() {
      this.showModal = true;
    },
    validate() {
      this.$v.$touch();
    },
    async onSubmit() {
      this.validate();
      if (!this.$v.$invalid) {
        try {
          this.reservationNotFound = false;
          this.loading = true;
          var response = await OfferRequestService.getReservationByProgress({
            progress: parseInt(this.model.progress),
            email: this.model.email,
            startDate: this.value.toISOString(),
            propertyCODE: this.propertyCODE,
          });

          if (response.data && response.data.length > 0) {
            this.populateReservationsFound(response.data);
            this.populateInfoContact(response.data[0]);
            // this.setSessionStorage(response.data, 'reservation');
          } else {
            this.reservationNotFound = true;
          }
        } catch (e) {
          console.log(e);
        }
        this.loading = false;
        // this.$emit('reservationFound', this.model);
      }
    },
    populateReservationsFound(reservations) {
      this.reservations = [];
      reservations.forEach((reservation) => {
        this.reservations.push({
          reservationID: reservation.reservationID,
          progress: reservation.progress,
          checkIn: format(reservation.checkIn, 'DD-MM-YYYY'),
          checkOut: format(reservation.checkOut, 'DD-MM-YYYY'),
        });
      });
    },
    populateInfoContact(model) {
      Object.assign(this.model, model);
      // this.model.reservationID = model.reservationID;
      // this.model.email = model.email;
      // this.model.firstName = model.firstName;
      // this.model.lastName = model.lastName;
      // this.model.phoneNumber = model.phoneNumber;
    },
    findReservationSkip() {
      this.$emit('findReservationSkipped');
    },

    setSessionStorage(model, key) {
      LocalStorage.set(model, key);
    },
    connectReservation(progress) {
      let selected = this.reservations.find((x) => x.progress == progress);
      this.model.reservationID = selected.reservationID;
      this.$emit('reservationFound', this.model);
    },
  },
};
</script>

<style></style>
